/// i18next configured to read the ARB-derived JSON directly.
///
/// The ICU plugin is what makes that possible: ARB message bodies are ICU
/// MessageFormat, so `{value}m` works verbatim with no rewriting into
/// i18next's native `{{value}}` syntax. mobile/lib/l10n stays authoritative.

import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import { readLocale } from '@/settings/data/settingsLocalData';
import { resources, supportedLocales } from './resources';

void i18next
  .use(ICU)
  .use(initReactI18next)
  .init({
    resources,
    lng: readLocale(),
    fallbackLng: 'en',
    supportedLngs: [...supportedLocales],
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export { i18next };
